import React from 'react';
import { LoadingFullScreenStyled } from './styles';

const LoadingFullScreen = ({ loading = false }) => {
  return loading ? (
    <LoadingFullScreenStyled>
      <div className="lds-facebook">
        <div />
        <div />
        <div />
      </div>
    </LoadingFullScreenStyled>
  ) : (
    <></>
  );
};

export default React.memo(LoadingFullScreen);
